<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters class="mb-10">
      <v-col cols="12">
        <v-card class="mobile-card" flat>
          <v-card-text class="text-wrap">
            <h3>A T4 Sports é uma equipe de treinamento nas modalidades:</h3>
            <p>Corrida - Natação no mar - Ciclismo - Triathlon - Treinamento funcional</p>

            <h4 class="mb-5">O que fazemos?</h4>
            <v-row>
              <v-col cols="12">
                <v-card class="elevation-3 mb-4 pa-0 card-gradient" flat>
                  <v-img :src="require('@/assets/images/sport-swim.jpg')" class="img-gradient"></v-img>
                  <v-card-text class="text-overlay white--text">
                    <strong>Natação no Mar:</strong> Marcação com bóias, orientação e suporte dentro d'água com caiaque.
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-card class="elevation-3 mb-4 pa-0 card-gradient" flat>
                  <v-img :src="require('@/assets/images/sport-run.jpg')" class="img-gradient"></v-img>
                  <v-card-text class="text-overlay white--text">
                    <strong>Corrida:</strong> Treinamento com educativos para melhorar a técnica de corrida e circuito na areia.
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-card class="elevation-3 mb-4 pa-0 card-gradient" flat>
                  <v-img :src="require('@/assets/images/sport-crossfit.jpg')" class="img-gradient"></v-img>
                  <v-card-text class="text-overlay white--text">
                    <strong>Treinamento Funcional:</strong> Foco em fortalecimento e ganho de volume muscular.
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-card class="elevation-3 mb-4 pa-0 card-gradient" flat>
                  <v-img :src="require('@/assets/images/tobias-bike.jpg')" class="img-gradient"></v-img>
                  <v-card-text class="text-overlay white--text">
                    <strong>Ciclismo:</strong> Treinos técnicos na rua e no rolo (treinamento estacionário).
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <h4 class="mt-4">Horários de Treinamento Coletivo</h4>
            <p><strong>Enseada de Botafogo:</strong> Corrida - Ciclismo (rolo) - Circuito na areia - Treinamento funcional</p>
            <p>3° a 6° feira - 06:00hs - 09:00hs / Sábados - 07:30hs - 10:30hs</p>
            <p><strong>Praia de Copacabana:</strong> Natação no mar - corrida / 4° e 6° feira - 06:00hs - 09:00hs</p>
            <p><strong>Outros locais:</strong> Ciclismo de rua (1 vez por mês) - Vista Chinesa / Cidade Universitária</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "WelcomeMobile",
};
</script>

<style scoped>
.mobile-card {
  background-color: transparent;
  max-width: 100%;
}

.text-wrap {
  word-wrap: break-word;
}

.img-gradient {
  height: 200px;
  background-size: cover;
  background-position: center;
  position: relative;
}

.card-gradient {
  position: relative;
  overflow: hidden;
}

.card-gradient::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0.7) 100%);
  z-index: 1;
}

.text-overlay {
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 2;
  color: white; /* This ensures the text is always white */
}
</style>
